import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DataTieringRepositories } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { REPOSITORIES_QUERY_KEY } from "../constants";
const useDeleteRepository = () => {
  const queryClient = useQueryClient();
  const deleteRepository = useMutation({
    mutationFn: (repositoryName) => DataTieringRepositories.remove(repositoryName),
    onSuccess: (_data, repositoryName) => {
      UserNotification.success(`Repository "${repositoryName}" has been deleted.`);
      queryClient.invalidateQueries({ queryKey: [REPOSITORIES_QUERY_KEY] });
    }
  });
  return {
    onDeleteRepository: deleteRepository.mutateAsync
  };
};
export default useDeleteRepository;
